export { default } from "./link-details-field";
